const round = (value: number, decimals: number): number => {
  return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
};

const squareMeterToHectare = (squareMeters: number): number => {
  return squareMeters / 10000;
};

export {
  round,
  squareMeterToHectare,
};
